/**
 * © 2026 iTech India Private Limited. All rights reserved.
 * Licensed under the iTech End User License Agreement (EULA).
 * Unauthorized use or distribution is prohibited.
 */

import { type JSX } from 'react';

import { InvoicesView } from './invoices-view.js';

/** Finance portal → Invoices (Figma). Full manage surface. */
export function FinanceInvoicesPage(): JSX.Element {
  return (
    <InvoicesView
      titleKey="finance.invoices.title"
      subtitleKey="finance.invoices.count"
      canManage
    />
  );
}
